//Assessments
import AssessmentFormQuestionMatrixOption from "./AssessmentFormQuestionMatrixOption"

//PrimeReact
import { classNames } from "primereact/utils"

//styling
import myStyles from "../../../styles/assessments/AssessmentForm.module.css"
import assessStyles from "../../../styles/assessments/Assessment.module.css"

export default function AssessmentFormQuestionMatrix({
  question,
  answers,
  scores,
  valueFieldName,
  readOnly,
  displayScore,
}) {
  let labelMinWidth = 50
  let optionWidth

  if (!question?.options) {
    labelMinWidth = 80
    optionWidth = 20
  } else {
    optionWidth =
      (100 - labelMinWidth - (displayScore ? 10 : 0)) / question.options.length
  }

  const GetScore = ({ questionLabel }) => {
    const score = scores?.find(
      (scoreValue) => scoreValue.questionId === questionLabel.id
    )?.score
    return score !== null && score !== undefined ? (
      <div
        className={classNames(
          myStyles.matrixQuestionOption,
          assessStyles.scoreValue
        )}
      >
        <span>{score}</span>
      </div>
    ) : null
  }

  return (
    <table className={myStyles.matrixQuestionTable}>
      <thead>
        <tr>
          <th style={{ minWidth: `${labelMinWidth}%` }}></th>
          {question.options.map((option) => (
            <th
              className={myStyles.matrixQuestionOptionHeader}
              style={{ width: `${optionWidth}%` }}
            >
              {option.text}
            </th>
          ))}
          {displayScore && (
            <th
              className={classNames(myStyles.matrixQuestionOptionHeader)}
              style={{ width: `10%` }}
            >
              <span className={assessStyles.scoreLabel}>Score</span>
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {question.questionLabels.map((label) => (
          <tr>
            <td className={myStyles.matrixQuestionOptionTextColumn}>
              {label.text}
            </td>
            {question.options.map((option) => (
              <td className={myStyles.matrixQuestionOptionColumn}>
                <AssessmentFormQuestionMatrixOption
                  label={label}
                  option={option}
                  answers={answers}
                  valueFieldName={valueFieldName}
                  question={question}
                  readOnly={readOnly}
                />
              </td>
            ))}
            {displayScore && (
              <td className={myStyles.matrixQuestionOptionColumn}>
                <GetScore questionLabel={label} />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
